import React from 'react'

const TurnaroundShutdownInspectionSupport = () => {
  return (
    <section className="services-details pt-120 pb-120">
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <div className="section-title" />
          </div>
          <div className="col-lg-6">
            <div className="section-title" />
          </div>
          {/*Start Services Details Content*/}
          <div className="col-xl-12 col-lg-12">
            <div className="services-details__content">
              <h3>Turnaround and Shutdown Inspection Support </h3>
              <p className="mb-30">
                Industrial plants, refineries, and processing facilities require
                periodic maintenance to ensure safe, efficient, and
                uninterrupted operation. During planned shutdowns or
                turnarounds, critical equipment is inspected, repaired, and
                kept. These inspections are essential to detect potential
                failures, prevent unplanned downtime, and follow safety and
                environmental regulations. International standards have been set
                up to ensure inspections during shutdowns are thorough,
                accurate, and consistent across industries.
              </p>
              <div className="content mt-40">
                <div className="text">
                  <h3 className="mb-4">Benefits of Our Service</h3>
                  <p className="mb-30">
                    Our turnaround and shutdown inspection support helps
                    clients:
                  </p>
                  <ul className="project-list">
                    <li className="d-flex align-items-center">
                      <i className="icon fa-classic fa-solid fa-check fa-fw" />{" "}
                      Identifying potential equipment failures before they
                      escalate into costly problems
                    </li>

                    <li className="d-flex align-items-center">
                      <i className="icon fa-classic fa-solid fa-check fa-fw" />{" "}
                      Minimizing unplanned downtime and ensuring facilities
                      resume operations on schedule
                    </li>

                    <li className="d-flex align-items-center">
                      <i className="icon fa-classic fa-solid fa-check fa-fw" />{" "}
                      Ensuring compliance with industry and safety regulations
                      while reducing operational risks
                    </li>

                    <li className="d-flex align-items-center">
                      <i className="icon fa-classic fa-solid fa-check fa-fw" />{" "}
                      Extending the lifespan of critical assets through timely
                      maintenance and repair recommendations
                    </li>
                  </ul>
                </div>
              </div>
              <div className="service-nr-list">
                <h3 className="mb-5">Our Services </h3>
                <p className="mb-30">
                  We provide expert inspection services during plant shutdowns
                  and turnarounds, including visual, mechanical, and
                  non-destructive testing (NDT) inspections. Our team
                  coordinates efficiently with maintenance crews to deliver
                  correct inspection reports, prioritize critical repairs, and
                  support safe and timely plant restart.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TurnaroundShutdownInspectionSupport